import { type RouteParamsType, type RouteType } from '@/defs/route'

export type TabType<K extends keyof RouteParamsType = never> = {
  label: string
  route: Partial<RouteType> & { [P in K]: RouteParamsType[P] | undefined }
  value: string
}

export type TabValidType = 'averageDeck' | 'charts' | 'combos' | 'decks' | 'similar'

export const TAB_DEFAULT = 'default'

export const TABS_COLOR_ID: TabType[] = [
  {
    label: '{{icon|colorId}} Commanders',
    route: { section: 'commandersList' },
    value: 'commanders',
  },
  {
    label: '{{icon|colorId}} Cards',
    route: { section: 'top' },
    value: 'cards',
  },
  {
    label: 'Staples in {{icon|colorId}} Decks',
    route: { section: 'staples' },
    value: 'staples',
  },
  {
    label: 'Mana Rocks {{icon|in colorId Decks}}',
    route: { section: 'manaRocks' },
    value: 'mana-rocks',
  },
  {
    label: '{{icon|colorId}} Landbases',
    route: { section: 'landsList' },
    value: 'landbases',
  },
  {
    label: '{{icon|colorId}} Combos',
    route: { section: 'combos' },
    value: 'combos',
  },
] as const

export const TABS_COMMANDER_FEATURED: TabType[] = [
  {
    label: 'Card Recs',
    route: { tab: '' },
    value: 'recs',
  },
  {
    label: 'Average Deck',
    route: { tab: 'average-deck' },
    value: 'average-deck',
  },
  {
    label: 'Decks',
    route: { tab: 'decks' },
    value: 'decks',
  },
  {
    label: 'Charts',
    route: { tab: 'charts' },
    value: 'charts',
  },
  {
    label: 'Combos',
    route: { tab: 'combos' },
    value: 'combos',
  },
  {
    label: 'Similar Commanders',
    route: { tab: 'similar-commanders' },
    value: 'similar-commanders',
  },
] as const

export const TABS_CARD_FEATURED: TabType[] = [
  {
    label: 'Card Recs',
    route: { tab: '' },
    value: 'recs',
  },
  {
    label: 'Charts',
    route: { tab: 'charts' },
    value: 'charts',
  },
  {
    label: 'Combos',
    route: { tab: 'combos' },
    value: 'combos',
  },
  {
    label: 'Similar Cards',
    route: { tab: 'similar-cards' },
    value: 'similar-cards',
  },
] as const

export const TABS_TAGS: TabType<'tagCategorySlug'>[] = [
  {
    label: 'All Tags',
    route: { section: 'tagsList', tagCategorySlug: undefined },
    value: 'all',
  },
  {
    label: 'Themes',
    route: { section: 'tagsList', tagCategorySlug: 'themes' },
    value: 'themes',
  },
  {
    label: 'Typal',
    route: { section: 'tagsList', tagCategorySlug: 'typal' },
    value: 'typal',
  },
  {
    label: 'Companions',
    route: { section: 'companions', tagCategorySlug: undefined },
    value: 'companions',
  },
] as const

export const TABS_SALT: TabType[] = [
  {
    label: '2026',
    route: { tab: '' },
    value: '2026',
  },
  {
    label: '2025',
    route: { tab: '2025' },
    value: '2025',
  },
  {
    label: '2024',
    route: { tab: '2024' },
    value: '2024',
  },
  {
    label: '2023',
    route: { tab: '2023' },
    value: '2023',
  },
  {
    label: '2022',
    route: { tab: '2022' },
    value: '2022',
  },
  {
    label: '2021',
    route: { tab: '2021' },
    value: '2021',
  },
  {
    label: '2020',
    route: { tab: '2020' },
    value: '2020',
  },
  {
    label: '2019',
    route: { tab: '2019' },
    value: '2019',
  },
] as const

export const TABS_PRECON: TabType[] = [
  {
    label: 'Adds',
    route: { tab: '' },
    value: 'adds',
  },
  {
    label: 'Cuts',
    route: { tab: 'cuts' },
    value: 'cuts',
  },
] as const
